import Vue from "vue";
import VNode from "@zj/ne-captcha.vue";

//extend 是构造一个组件的语法器.传入参数，返回一个组件
const VNodeConstructor = Vue.extend(VNode);

const initInstance = (function() {
  let instance = null;
  return function() {
    if (!instance) {
      //实例化ConfirmConstructor组件
      instance = new VNodeConstructor({
        el: document.createElement("div")
      });
      //添加到boby
      // instance.$mount('#app');
      document.body.appendChild(instance.$el);
    }
    return instance;
  };
})();
// const initInstance = () => {
//   //实例化ConfirmConstructor组件
//   instance = new VNodeConstructor({
//     el: document.createElement('div'),
//   });
//   //添加到boby
//   instance.$mount('body');
// };

let nodeFn = () => {
  //初始化
  const CNode = initInstance();
  // console.log(CNode);

  return CNode.verify();
  // 将单个 confirm instance 的配置合并到默认值（instance.$data，就是main.vue里面的data）中
  // console.log(CNode.$data);
  // merge(CNode.$data, options);
  // console.log(CNode.$data);
  //返回Promise
  // return new Promise((resolve, reject) => {
  //   CNode.show();
  //   let comfirm = CNode.comfirm;
  //   let exit = CNode.exit;
  //   CNode.comfirm = () => {
  //     //先执行CNode.success（main.vue里面的success函数）
  //     comfirm();
  //     //再执行自定义函数
  //     resolve(CNode.yes.value);
  //   };
  //   CNode.exit = () => {
  //     //先执行CNode.success（main.vue里面的success函数）
  //     exit();
  //     //再执行自定义函数
  //     resolve(CNode.no.value);
  //   };
  // });
};

const install = function(Vue) {
  //注册全局组件
  Vue.component("neCaptchaVerify", nodeFn);
  //添加全局API
  Vue.prototype.neCaptchaVerify = nodeFn;
  // window._alertMessage = $node;
};

export default install;
